import { M3CONDIAGRUPACION } from "./M3CONDIAGRUPACION.class";

export class M3ENCPROMO{
    public IdPromocion:number;
    public Nombre:string;
    public Tipo:string;
    public Tipo2:string;
    public Vigencia:Date;
    public Inicio:Date;
    public Estado:boolean;
    public JAdicionales:string;

    public EstadoManuales:boolean =false;
    public EsManual:boolean= false;

    public EstadoAplCupon:boolean =false;
    public EsAplCupon:boolean= false;
    public Tope:number;

    public M3CONDIAGRUPACION:Array<M3CONDIAGRUPACION>;
}